function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

export function getCookie(name) {
  var cookies = document.cookie ? document.cookie.split('; ') : [];
  var prefix = "".concat(encodeURIComponent(name), "=");
  var cookie = cookies.find(function (cookie) {
    return cookie.startsWith(prefix);
  });

  if (cookie) {
    var value = cookie.split('=').slice(1).join('=');

    if (value) {
      return decodeURIComponent(value);
    }
  }
}
export function compact(object) {
  var result = {};

  for (var key in object) {
    var value = object[key];

    if (value !== undefined) {
      result[key] = value;
    }
  }

  return result;
}
export function metaContent(name) {
  var element = document.head.querySelector("meta[name=\"".concat(name, "\"]"));
  return element && element.content;
}
export function stringEntriesFromFormData(formData) {
  return _toConsumableArray(formData).reduce(function (entries, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        value = _ref2[1];

    return entries.concat(typeof value === 'string' ? [[name, value]] : []);
  }, []);
}
export function mergeEntries(searchParams, entries) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref5 = _step.value;

      var _ref4 = _slicedToArray(_ref5, 2);

      var name = _ref4[0];
      var value = _ref4[1];
      if (value instanceof window.File) continue;

      if (searchParams.has(name) && !name.includes('[]')) {
        searchParams["delete"](name);
        searchParams.set(name, value);
      } else {
        searchParams.append(name, value);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}